<template>
  <div id="lista-questoes" class="col-12 col-lg-3 sim-questoes order-1 order-md-1">
  <div class="d-flex justify-content-between align-items-center">
    <a href="javascript:void(0)" v-on:click.prevent="questaoAnterior()" v-bind:class="{ disabled: !possuiQuestaoAnterior() }"><i class="fas fa-chevron-left"></i></a>
    <p>{{ ordem }}<span> de {{ quantidadeQuestoes }}</span></p>
    <a href="javascript:void(0)" v-on:click.prevent="proximaQuestao()" v-bind:class="{ disabled: !possuiProximaQuestao() }"><i class="fas fa-chevron-right"></i></a>
  </div>
  <div class="row mt-3">
    <div v-for="questao in questoes" class="col-2">
      <a :class="obterClassQuestao(questao)" v-on:click="selecionaQuestao(questao)">
        {{questao.ordem}}
      </a>
    </div>
  </div>
  <div class="mt-4 mb-4">
    <ul>
      <li>Respondidas</li>
      <li>Atual</li>
      <li>Não respondidas</li>
    </ul>
  </div>
  </div>
</template>
<script>
export default {
  name: 'ListaQuestoes',
  props: {
    questoes: Array
  },
  data: function () {
    return {
      ordemAtual: 1,
      quantidadeQuestoes: 0,
      ordem: 1
    }
  },
  mounted () {
    this.quantidadeQuestoes = this.questoes.length
    window.eventBus.$on('selecionaQuestao', (data) => {
      this.ordem = data.ordem
    })
  },
  watch: {
    questoes: function () {
      this.quantidadeQuestoes = this.questoes.length
    }
  },
  methods: {
    selecionaQuestao (questao) {
      this.ordem = questao.ordem
      window.eventBus.$emit('selecionaQuestao', questao)
    },
    obterClassQuestao: function (questao) {
      if (this.ordem === questao.ordem) {
        return 'atual'
      } else if (questao.respondida) {
        return 'respondida'
      }
    },
    possuiQuestaoAnterior: function () {
      return this.questoes.length && this.ordem > this.questoes[0].ordem
    },

    possuiProximaQuestao: function () {
      return this.ordem < this.quantidadeQuestoes
    },

    questaoAnterior: function () {
      if (this.possuiQuestaoAnterior()) {
        this.selecionaQuestao(this.questoes[this.questoes.findIndex(item => item.ordem === this.ordem) - 1])
      }
    },

    proximaQuestao: function () {
      if (this.possuiProximaQuestao()) {
        this.selecionaQuestao(this.questoes[this.questoes.findIndex(item => item.ordem === this.ordem) + 1])
      }
    }
  }
}
</script>
